import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavBarLateral } from "../vendedor/NavBarLateral";
import alertService from "../../_services/cart/alert.service";
import suscripcionService, { formatoFecha, SITUACIONES, tonoSituacion } from "../../_services/cart/suscripcion.service";
import { ImpersonarCuentaModal } from "./utils/ImpersonarCuentaModal";
import { UsoIaAdmin } from "./UsoIaAdmin";

/**
 * Administracion > Suscripciones: todas las cuentas de vendedor con su situacion. Arriba, lo que pide
 * atencion (pruebas por vencer, pagos pendientes, pruebas vencidas); el detalle y las acciones estan en la
 * ficha del usuario.
 */
export const SuscripcionesAdmin = () => {
    const [cuentas, setCuentas] = useState([]);
    const [planes, setPlanes] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [situacion, setSituacion] = useState("");
    const [plan, setPlan] = useState("");
    const [texto, setTexto] = useState("");
    const [busqueda, setBusqueda] = useState("");
    const [impersonar, setImpersonar] = useState(null);
    const cerrarImpersonar = useCallback(() => setImpersonar(null), []);

    const cargar = useCallback(() => {
        setCargando(true);
        suscripcionService
            .adminListar({ situacion, plan, q: busqueda })
            .then((r) => {
                setCuentas(r.cuentas || []);
                setPlanes(r.planes || []);
            })
            .catch((err) => alertService.error(err))
            .finally(() => setCargando(false));
    }, [situacion, plan, busqueda]);

    useEffect(() => {
        cargar();
    }, [cargar]);

    const vence = (c) => {
        if (c.situacion === "PRUEBA") return `${formatoFecha(c.endDate)} (${c.diasRestantes} ${c.diasRestantes === 1 ? "día" : "días"})`;
        if (c.situacion === "ACTIVA" && c.nextPaymentDate) return `Próximo cobro ${formatoFecha(c.nextPaymentDate)}`;
        if (c.endDate) return formatoFecha(c.endDate);
        return "—";
    };

    return (
        <div className="dashboard">
            <NavBarLateral handleClose={() => {}} />

            <div className="dashboard__content cuenta-usuarios">
                <div className="dashboard__content-header cuenta-usuarios__header">
                    <div className="dashboard__content-title">
                        <p className="cuenta-usuarios__eyebrow">ADMINISTRACIÓN</p>
                        <h2>Suscripciones</h2>
                        <p className="panel__bajada">
                            Las cuentas de vendedor y su plan. Primero lo que pide atención: pruebas por vencer, pagos
                            pendientes y pruebas vencidas. Para cambiar algo, entrá a la ficha del usuario.
                        </p>
                    </div>
                </div>

                <section className="cuenta-usuarios__card suscripcion-admin__filtros">
                    <div>
                        <label className="cuenta-usuarios__label">Situación</label>
                        <select className="cuenta-usuarios__select" value={situacion} onChange={(e) => setSituacion(e.target.value)}>
                            <option value="">Todas</option>
                            {Object.entries(SITUACIONES).map(([k, v]) => (
                                <option key={k} value={k}>{v}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="cuenta-usuarios__label">Plan</label>
                        <select className="cuenta-usuarios__select" value={plan} onChange={(e) => setPlan(e.target.value)}>
                            <option value="">Todos</option>
                            {planes.map((p) => (
                                <option key={p.id} value={p.codigo}>{p.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="suscripcion-admin__buscar">
                        <label className="cuenta-usuarios__label">Cuenta o email del dueño</label>
                        <div className="cuenta-usuarios__buscador">
                            <input type="text" value={texto} placeholder="Ej: repuestos@..."
                                   onChange={(e) => setTexto(e.target.value)}
                                   onKeyUp={(e) => e.key === "Enter" && setBusqueda(texto)} />
                            <button type="button" className="button" data-type="primary" onClick={() => setBusqueda(texto)}>
                                <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" /> Buscar
                            </button>
                        </div>
                    </div>
                </section>

                <section className="cuenta-usuarios__card cuenta-usuarios__tabla-card">
                    {cargando && <p className="panel__estado-carga">Cargando…</p>}
                    {!cargando && cuentas.length === 0 && <p className="cuenta-usuarios__vacio">No hay cuentas con esos filtros.</p>}
                    {!cargando && cuentas.length > 0 && (
                        <div className="suscripcion-admin__tabla">
                            <table className="cuenta-usuarios__tabla">
                                <thead>
                                    <tr>
                                        <th>Cuenta</th>
                                        <th>Plan</th>
                                        <th>Situación</th>
                                        <th>Vence / próximo cobro</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cuentas.map((c) => (
                                        <tr key={c.cuentaId}>
                                            <td>
                                                <p className="cuenta-usuarios__nombre">{c.cuentaNombre}</p>
                                                <p className="cuenta-usuarios__username">{c.duenoEmail}</p>
                                            </td>
                                            <td>{c.planNombre || "—"}</td>
                                            <td>
                                                <span className="suscripcion-admin__chip" data-tono={tonoSituacion(c.situacion)}>
                                                    {SITUACIONES[c.situacion] || c.situacion}
                                                </span>
                                            </td>
                                            <td>{vence(c)}</td>
                                            <td>
                                                <Link className="cuenta-usuarios__icono" title="Ver ficha del usuario"
                                                      to={`/admin/userDetail?id=${c.duenoId}`}>
                                                    <FontAwesomeIcon icon="fa-solid fa-eye" />
                                                </Link>
                                                <button type="button" className="cuenta-usuarios__icono"
                                                        title="Entrar como alguien de la cuenta"
                                                        onClick={() => setImpersonar(c)}>
                                                    <FontAwesomeIcon icon="fa-solid fa-user-secret" />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                    {!cargando && cuentas.length > 0 && (
                        <p className="cuenta-usuarios__vacio suscripcion-admin__total">
                            {cuentas.length} {cuentas.length === 1 ? "cuenta" : "cuentas"}
                        </p>
                    )}
                </section>

                <UsoIaAdmin />
            </div>

            <ImpersonarCuentaModal cuenta={impersonar} onClose={cerrarImpersonar} />
        </div>
    );
};
